import { Spin } from "antd";
import React, { FC } from "react";
import { LoadingOutlined } from '@ant-design/icons';

import "./loadingComponent.scss";
export const LoadingComponent: FC<{title?: string}> = ({title}) => {
  return (
    <div className="loading__container">
      <Spin tip={title ? title : "Fetching details..."} indicator={<LoadingOutlined spin/>}/>
    </div>
  );
};
